<template>
  <div>
    <el-carousel height="2.9rem" :autoplay="true" :interval="5000">
      <el-carousel-item>
        <img src="../../assets/images/banner/product/zhaq/1.jpg" width="100%" height="100%">
      </el-carousel-item>
      <el-carousel-item>
        <img src="../../assets/images/banner/product/zhaq/2.jpg" width="100%" height="100%">
      </el-carousel-item>
      <el-carousel-item>
        <img src="../../assets/images/banner/product/zhaq/3.jpg" width="100%" height="100%">
      </el-carousel-item>
    </el-carousel>
    <div class="box2">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
        <el-menu-item index="1" @click="$router.push('productSite')">智慧工地</el-menu-item>
        <el-menu-item index="2" @click="$router.push('productSafety')">智慧安全</el-menu-item>
        <el-menu-item index="3" @click="$router.push('productCartoon')">工程动画</el-menu-item>
      </el-menu>
    </div>
    <div class="select-box">
      <div class="btn" v-for="(item,index) in btnList" :class="{'selected':selectedIndex === index}"
           @click="changeSelected(item,index)">
        <img :src="item.img">
        <p>{{ item.name }}</p>
      </div>
    </div>
<!--    <div class="content">-->
<!--      <div class="lef">-->
<!--        <div>智慧工地产品</div>-->
<!--        <p v-for="(item,index) in btnList" :key="item.id">-->
<!--          <a :class="{'don':selectedIndex === index}" @click="changeSelected(item,index)">· {{ item.name }}</a>-->
<!--        </p>-->
<!--      </div>-->
<!--      <div class="right">-->
<!--        <component :is="selectedPage"></component>-->
<!--        <div class="but">-->
<!--          <span class="l" @click="upClick()">上一篇</span>-->
<!--          <span class="r" @click="nextClick()">下一篇</span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import yitiji from "./product-safety-page/yitiji";
import mohe from "@/components/product/product-safety-page/mohe";
import yitiji2 from "@/components/product/product-safety-page/yitiji2";
import jingda from "@/components/product/product-safety-page/jingda";
import laobao from "@/components/product/product-safety-page/laobao";
import biaozhi from "@/components/product/product-safety-page/biaozhi";
import ele from "@/components/product/product-safety-page/ele";
import qita from "@/components/product/product-safety-page/qita";
import safetyVR from "@/components/product/product-safety-page/safetyVR";
import dangVR from "@/components/product/product-safety-page/dangVR";


export default {
  components: {
    yitiji, mohe, yitiji2, jingda, laobao, biaozhi, ele, qita, safetyVR, dangVR
  },
  data() {
    return {
      activeIndex: '2',
      btnList: [
        {name: '安全教育一体机', page: 'yitiji', img: require('./img/safety/1.jpg')},
        {name: '安全教育魔盒', page: 'mohe', img: require('./img/safety/2.jpg')},
        {name: '安全教育培训箱一体机', page: 'yitiji2', img: require('./img/safety/3.jpg')},
        {name: '安全知识竞答系统', page: 'jingda', img: require('./img/safety/4.jpg')},
        {name: '劳保用品穿戴认知教学', page: 'laobao', img: require('./img/safety/5.jpg')},
        {name: '安全标志认知教学', page: 'biaozhi', img: require('./img/safety/6.png')},
        {name: '安全用电认知教学', page: 'ele', img: require('./img/safety/7.jpg')},
        {name: '其他认知教学产品', page: 'qita', img: require('./img/safety/8.png')},
        {name: 'VR安全体验馆', page: 'safetyVR', img: require('./img/safety/9.png')},
        {name: '党建VR体验', page: 'dangVR', img: require('./img/safety/10.png')},
      ],
    }
  },
  methods: {
    changeSelected(__item, __index) {
      this.$router.push({path: 'productSafetyDetail', query: {index: __index}});
    },
    upClick() {
      if (this.selectedIndex === 0) {
        return;
      }
      this.selectedIndex--;
      this.selectedPage = this.btnList[this.selectedIndex].page;
      document.documentElement.scrollTop = 800;
    },
    nextClick() {
      if (this.selectedIndex === this.btnList.length - 1) {
        return;
      }
      this.selectedIndex++;
      this.selectedPage = this.btnList[this.selectedIndex].page;
      document.documentElement.scrollTop = 800;
    },
  }
}
</script>

<style lang="scss" scoped>
.box {
  height: 2.9rem;
  width: 100%;
  background: url("../../assets/images/zh.jpg");
  background-size: 100% 100%;
}

.box2 {
  width: 6.24rem;
  margin: .34rem auto .2rem;
  text-align: center;

  a {
    text-decoration: none;
  }

  .el-menu-item {
    width: 2.08rem;
    font-size: .2rem;
    height: .72rem;
    line-height: .72rem;
  }

  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 3px solid #E70F20;
    color: #E70F20;
  }

  .el-menu--horizontal > .el-menu-item {
    color: #000;
  }
}

.select-box {
  display: flex;
  flex-wrap: wrap;
  width: 12rem;
  margin: 0 auto .2rem;

  .btn {
    border: 1px solid #cfcfcf;
    margin-right: .1rem;
    margin-bottom: .1rem;
    cursor: pointer;
    overflow: hidden;
    position: relative;

    &:hover {
      img {
        transform: scale(1.2);
        transition: .5s;
      }

      color: #E71120;
    }

    &.selected {
      border: 1px solid #E71120;
      color: #E71120;
    }

    img {
      display: block;
      width: 2.25rem;
      height: 2.25rem;
    }

    p {
      height: .4rem;
      line-height: .4rem;
      position: absolute;
      width: 100%;
      bottom: 0;
      z-index: 2;
      text-align: center;
      background: #f1f1f1;
    }
  }
}

.content {
  width: 12rem;
  margin: .5rem auto 0;
  display: flex;

  .lef {
    margin-right: .24rem;
    width: 1.76rem;
    overflow: hidden;

    div {
      font-size: .2rem;
      position: relative;
      padding-left: .1rem;
      margin-bottom: .19rem;
    }

    div::before {
      position: absolute;
      content: "";
      left: 0rem;
      top: .06rem;
      background: #E70F20;
      width: 2px;
      height: .16rem;
    }

    p {
      line-height: .34rem;
      font-size: .16rem;
      width: 1.76rem;
      color: #3F3F3F;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      cursor: pointer;

      a {
        display: inline-block;
        width: 100%;
      }
    }

    .don {
      color: #E70F20
    }
  }

  .right{
    .but {
      text-align: center;
      margin-top: .56rem;

      span {
        width: 69px;
        height: 26px;
        line-height: 29px;
        display: inline-block;
        font-size: 12px;
        margin: 0 .25rem;
        cursor: pointer;
      }

      .l {
        background: url("../../assets/images/pg.png");
        background-size: 100% 100%;
        padding-left: .07rem
      }

      .r {
        background: url("../../assets/images/pg2.png");
        background-size: 100% 100%;
        padding-right: .07rem
      }
    }
  }
}


</style>
